import { UserRole } from "./user-roles.enum";
import { Permission } from "./permission.enum";

export const rolePermissions: { [key: string]: Permission[] } = {
    [UserRole.TapestryAdmin]: [
        Permission.CanAccessUserManagement,
        Permission.CanAccessAnnouncementManagement,
        Permission.CanAccessQualityAudit
    ],
    [UserRole.TapestryQualityReviewer]: [
        Permission.CanAccessQualityAudit
    ],
    [UserRole.FacilityAdmin]: [
        Permission.CanAccessUserManagement
    ]
};